export default {
      id: "skip-back.sprite-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#skip-back.sprite-usage",
      toString: function () {
        return this.url;
      }
    }